import TableDatalayer from '@curry/table'

export default class TableApi {
  constructor({ config, transports }) {
    this.datalayer = new TableDatalayer({ config, transports });
  }

  get({shopId}) {
    return new Promise((resolve, reject) => {
      const args = { shop_id: shopId };
      this.datalayer.models[0].find({ args }).then((response) => {
        resolve(response.data);
      }).catch(reject);
    });
  }

  post(args) {
    return new Promise((resolve, reject) => {
      this.datalayer.models[0].save({item: args}).then((response) => {
        resolve(response.data);
      }).catch(reject);
    });
  }

}